<script lang="ts" setup>
import Login from '@/components/base/login/login-modal.vue'
// import CySearch from '@/components/ui/cy-search.vue'
import { useSystemStore, useUserStore, useSearchStore } from '@/stores'
import { useRouter, useRoute } from 'vue-router'
import { computed, ref, watch, watchEffect, unref, onUnmounted, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { EventBus } from '@/utils'
import { AppEventTypeEnum } from '@/utils/enums'
import useHomeState from '@/views/home/home-page.state'
import type { FrontendCategory, ShopInfo } from '@/types/shop-info'
// import DefaultPoster from '@/assets/image/default-poster.jpg';

const router = useRouter()
const route = useRoute()
const useSystem = useSystemStore()
const useUser = useUserStore()
const useSearch = useSearchStore()
const { t, locale } = useI18n()
const LIST_PATH = '/list'

// const isDebug = import.meta.env.DEV;

const loginModelRef = ref<InstanceType<typeof Login>>()
const getLocalStorageLang = computed(() => {
  const system = localStorage.getItem('system');
  if (system) {
    return JSON.parse(system).currentI18
  }
  return 'zh-CN'
})

const isLogin = computed(() => useUser.isLogin)
// const nickname = computed(() => useUser.nickname)
// const avatar = computed(() => useUser.avatar)
const rawCellphone = computed(() => useUser.rawCellphone)
// const isShowHeaderToHome = computed(() => useSystem.isShowHeaderToHome)
// const isShowHeader = computed(() => useSystem.isShowHeader)
const isShowLoginDialog = computed(() => useSystem.isShowLoginDialog)
// const currentI18 = computed(() => ('ZH'))
// const isShowTabbar = computed(() => useSystem.isShowTabbar)
const { getShopInfos } = useHomeState()
const homeNavList = ref<(FrontendCategory & { isActive: boolean })[]>([])

const handleNavClick = (item: any) => {
  // useChannelRouter().open(item.path,null, { channelId: route.query.channelId});
  if (item.bizFrontendCategoryId && !item.path.includes('topic-activity')) {
    router.push({
      path: item.path,
      query: {
        bizFrontendCategoryId: item.bizFrontendCategoryId
      }
    })
    useSystem.toggleNavPath(`${item.path}/?bizFrontendCategoryId=${item.bizFrontendCategoryId}`)
    return
  }
  router.push({
    path: item.path
  })
  useSystem.toggleNavPath(item.path)
}



watch(isShowLoginDialog, (newValue) => {
  if (!isLogin.value && newValue) {
    loginModelRef.value?.showLoginModal()
  }
})

// 根据路由切换导航活性状态
watch(() => useSystem.currentNavPath, () => {
  setBarActive();
})

const setBarActive = () => {
  homeNavList.value.forEach(item => item.isActive = false);
  const found = homeNavList.value.find(item => item.path?.includes('topic-activity') && useSystem.currentNavPath.startsWith(item.path || ''));
  if (useSystem.currentNavPath === '/') {
    const currentNav = homeNavList.value.find(item => item.path === '/');
    currentNav && (currentNav.isActive = true);
  } else if (useSystem.currentNavPath.includes(LIST_PATH)) {
    const item = homeNavList.value.find(item =>
      item.path?.includes(LIST_PATH) && useSystem.currentNavPath.includes(item.bizFrontendCategoryId!));
    if (item) {
      item.isActive = true;
    }
  } else if (found) {
    found.isActive = true;
  }
  if (useSearch.getContent()) {
    homeNavList.value.forEach(item => item.isActive = false);
  }
}

const stopToggleHeaderToHome = watchEffect(() => {
  const curRouter = route
  const _name = unref(curRouter.name)
  if (!_name) return
  if (_name === 'home' || _name === 'list' || _name === 'topic_activity') {
    useSystem.toggleSetting('HeaderToHome', false)
    useSystem.toggleSetting('Tabbar', true)
  } else {
    useSystem.toggleSetting('HeaderToHome', true)
    useSystem.toggleSetting('Tabbar', false)
  }
})

const showLoginModal = () => {
  loginModelRef.value?.showLoginModal()
}

const logout = (isBtn?: boolean) => {
  useUser.logout()
  if (isBtn) {
    router.push({ path: `/`, replace: true, });
  } else {
    if (isShowLoginDialog.value) {
      showLoginModal()
    }
  }
}

const toMinePage = () => {
  router.push({ path: '/user-center' })
}

const toggleI18 = (lang: 'en-US' | 'zh-CN') => {
  locale.value = lang
  useSystem.toggleSetting('I18', lang)
}

EventBus.$on(AppEventTypeEnum.RE_LOGIN, () => {
  logout()
})

// const generateNav = async () => {
//   homeNavList.value.push({ categoryName: "首页", path: '/', isActive: true })
//   homeNavList.value.push({ categoryName: "演出购票", path: '/list', isActive: false })
//   const slideData = useSystem.components?.find(opt => opt.type === "SLIDE_NAVIGATION")?.items;
//   slideData?.forEach((item)=>{
//     if (item.categoryType === 'B_CATEGORY_OR_TAG') {
//       item.path = LIST_PATH
//     } else {
//       item.categoryName = item.name;
//       item.categoryType = 'TOPIC'
//       item.path = `/topic-activity/${item.navigateUrl?.split('/').slice(-1)}`
//     }
//   })
//   slideData?.length && homeNavList.value.push(...slideData);
//   // 更新Active位置
//   setBarActive();
//   const shopConfig = await getShopInfos()
//   useSystem.saveShopConfig(shopConfig as ShopInfo);
//   // 持票须知&观演须知 - 通过后台配置
//   // homeNavList.value.push(
//   //   { categoryName: t('home.ticketHolderNotice'), path: '/notice' },
//   //   { categoryName: t('home.helpCenter'), path: '/support' }
//   // )
// }

const generateNav = async () => {
  const shopConfig = await getShopInfos()
  homeNavList.value.push({ categoryName: "首页", path: '/', isActive: true })
  homeNavList.value.push({ categoryName: "演出购票", path: '/list', isActive: false })
  useSystem.saveShopConfig(shopConfig as ShopInfo);
  shopConfig?.frontendCategories?.forEach((item: FrontendCategory) => {
    if (item.categoryType === 'B_CATEGORY_OR_TAG') {
      item.path = LIST_PATH
    } else {
      // 持票须知&帮助中心跳转至专题活动
      item.path = `/topic-activity/${item.navigateUrl?.split('/').slice(-1)}`
    }
  })
  // @ts-ignore
  shopConfig?.frontendCategories?.length && homeNavList.value.push(...shopConfig.frontendCategories)
  // 更新Active位置
  setBarActive();
  // 持票须知&观演须知 - 通过后台配置
  // homeNavList.value.push(
  //   { categoryName: t('home.ticketHolderNotice'), path: '/notice' },
  //   { categoryName: t('home.helpCenter'), path: '/support' }
  // )
}
const openTopic = (topicId:string) =>{
  if (topicId) {
    window.open(`${location.origin}/topic-activity/${topicId}`, '_blank')
    return
  }
}

const activeNav = (item: any) =>{
  if (item.categoryType === 'B_CATEGORY_OR_TAG' && route.fullPath.includes(item.bizFrontendCategoryId)) {
    return true;
  }
  if (item.categoryType === 'TOPIC' && item.navigateUrl?.includes(route.params?.topicId)) {
    return true;
  }
  if (item.categoryName === '首页' && route.fullPath === '/') {
    return true;
  }
  if (item.categoryName === '演出购票' && route.fullPath === '/list') {
    return true;
  }
}

onMounted(() => {
  generateNav()
})

onUnmounted(() => {
  stopToggleHeaderToHome()
})
</script>
<template>
<Login ref="loginModelRef"></Login>
<div class="header-layout">
  <div class="top-wrap">
    <div class="content">
      <div class="left">
        <div class="welcome" v-if="!rawCellphone">Hi，欢迎访问北京天桥艺术中心， 请 [ <span @click="showLoginModal">注册</span> | <span href="javascript:void(0);" @click="showLoginModal">登录</span> ] 
        </div>
        <div class="welcome" v-if="rawCellphone">您好{{rawCellphone}}，欢迎访问北京天桥艺术中心 [<span @click="logout">退出</span>]
        </div>
        <div @click="toMinePage" style="cursor: pointer;">[个人中心]</div>
      </div>
      <div class="right">
      <!-- <a href="javascript:void()" @click="openTopic('6708d63801ea8f0001e06794')">商户合作</a>
      <div class="split-line"></div> -->
      <a href="javascript:void()" @click="openTopic('6708d6fd5aaf9d0001034706')">客户服务</a>
      </div>
    </div>
  </div>
  <div class="logo-wrap">
    <div class="content">
      <img src="../../../assets/image/header-footer/logo.png" alt="" height="82" >
      <div class="right">
        <div class="split-line"></div>
        <div class="hot-line">
          <i class="ico ico-hotline-v"></i>
          <span>400-635-3355</span>
        </div>
        <div class="split-line"></div>
        <div class="qr-code">
          <div>
            <i class="ico"></i>
            <p class="scan">扫描二维码</p>
            <p class="download">关注天桥微信号</p>
            <img src="../../../assets/image/header-footer/code.jpg" alt="扫描加关注">
          </div>
        </div>
        <div class="split-line last"></div>
      </div>
    </div>
  </div>
  <div class="nav-wrap">
    <div class="content">
      <!-- <a class="nav-link" @click="router.push({ path: '/' })">首页</a> -->
      <!-- <a class="nav-link" @click="router.push({ path: '/list' })">演出购票</a> -->
      <a v-for="item in homeNavList" class="nav-link" :class="{'active': activeNav(item)}" @click="handleNavClick(item)"> {{item.categoryName}}</a>
      <!-- <a class="nav-link">影院动态</a>
      <a class="nav-link">优惠券</a>
      <a class="nav-link">会员俱乐部</a>
      <a class="nav-link">艺术教育</a>
      <a class="nav-link">艺术培训</a>
      <a class="nav-link">文创商店</a>
      <a class="nav-link">场次设施</a>
      <a class="nav-link">关于我们</a> -->
    </div>
  </div>
</div>
</template>
<style lang="less" scoped>
  .header-layout{
    .top-wrap{
      background: #F4F4F4;
      height: 44px;
      line-height: 44px;
      .content{
        width: 1062px;
        margin: 0 auto;
        height: 44px;
        line-height: 44px;
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        text-align: left;
        font-style: normal;
        text-transform: none;
        background: #F4F4F4;
        display: flex;
        justify-content: space-between;
        overflow-x: auto;
        overflow-y: hidden;
        span{
          cursor: pointer;
        }
        .left{
          display: inline-flex;
          align-items: center;
          .welcome{
            margin-right: 20px;
          }
        }
        .right{
          font-size: 14px;
          color: #999999;
          display: inline-flex;
          align-items: center;
          .split-line{
            height: 16px;
            width: 1px;
            background-color: #e5e5e5;
            margin: 0 28px;
          }
          a{
            color: #999;
          }
        }
      }
    }
    .logo-wrap{
      background: #FFFFFF;
      height: 98px;
      .content{
        width: 1062px;
        height: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .right{
          display: flex;
          justify-content: space-between;
          align-items: center;
          .split-line{
            height: 16px;
            width: 1px;
            background: #E5E5E5;
            margin: 0 28px;
          }
          .split-line.last{
            margin-right: 0;
          }
          .hot-line {
              display: flex;
              height: 36px;
              // margin-top: 36px;
              margin-left: 13px;
              padding-right: 14px;
              align-items: center;
              font-size: 14px;
          }

          .hot-line i {
              width: 30px;
              height: 30px;
              margin-right: 7px;
              display: inline-block;
              background: url(../../../assets/image/header-footer/tq_hot_line.png) no-repeat;
          }

          .hot-line span {
              font-weight: bold;
              color: #634271;
              font-size: 14px;;
          }
          .qr-code {
              position: relative;
              width: 159px;
              height: 36px;
              padding-right: 10px;
          }

          .qr-code div {
              position: absolute;
              top: 1px;
              left: 0;
              margin: -8px 0 0 5px;
              padding: 6px;
              border: 1px solid transparent;
              background: #ffffff;
              z-index: 90;
          }

          .qr-code div:hover {
              border: 1px solid #a9823e;
              box-shadow: 0 0 5px 1px #b5b5b5;
          }

          .qr-code div:hover .ico {
              background: url(../../../assets/image/header-footer/tq_qr_code.png) no-repeat;
          }

          .qr-code div:hover p {
              color: #a9823e;
          }

          .qr-code div:hover img {
              display: block;
              margin-top: 18px;
          }

          .qr-code .ico {
              float: left;
              width: 30px;
              height: 30px;
              margin-top: 3px;
              background: url(../../../assets/image/header-footer/tq_qr_code_grey.png) no-repeat;
          }

          .qr-code p {
              padding-left: 38px;
              font-size: 14px;
              text-align: center;
              color: #cbcbcb;
          }

          .qr-code .download {
              font-size: 14px;
          }

          .qr-code img {
              display: none;
              width: 80px;
              height: 80px;
              padding-left: 30px;
              box-sizing: content-box;
          }
        }
      }
    }
    .nav-wrap{
      border-top: 1px solid #eee;
      border-bottom: 2px solid #A9823E;
      background-color: #fff;
      .content{
        width: 1062px;
        margin: 0 auto;
        height: 84px;
        line-height: 84px;
        background: #FFFFFF;
        display: flex;
        justify-content: space-between;
        font-weight: 500;
        font-size: 16px;
        color: rgba(0,0,0,0.6);
        text-align: center;
        font-style: normal;
        text-transform: none;
        overflow-x: auto;
        overflow-y: hidden;
        .nav-link{
          margin-left: 10px;
          margin-right: 20px;
          flex-shrink: 0;
          &.active{
            color: #A9823E;
          }
        }
      }
    }
  }
</style>
